import React, { useEffect } from 'react';
import styles from './SideDrawer.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
  width?: number;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

const SideDrawer = ({ open, onClose, width = 680, footer, children }: Props) => {
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div className={styles.backdrop} data-test="side-drawer-backdrop" role="presentation" onClick={onClose}>
      <div
        className={styles.panel}
        data-test="side-drawer-panel"
        style={{ width }}
        role="dialog"
        aria-modal="true"
        onClick={e => e.stopPropagation()}
      >
        <div className={styles.body}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
};

export default SideDrawer;
